<div class="status-type">
    <ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
        [autoClearSearch]="false" [(ngModel)]="statusPhoto" placeholder="Seleccionar Estatus Foto"
        (select)="changeStatusPhoto($event)">
        <ng-template ngx-select-option-not-found let-input>
            "{{input}}" no encontrado
        </ng-template>
    </ngx-select>
</div>